import { render, staticRenderFns } from "./ScoreHeader.vue?vue&type=template&id=13891c78&scoped=true"
import script from "./ScoreHeader.vue?vue&type=script&lang=js"
export * from "./ScoreHeader.vue?vue&type=script&lang=js"
import style0 from "./ScoreHeader.vue?vue&type=style&index=0&id=13891c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13891c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VDivider,VList,VListItem,VMenu,VSpacer,VTextField})
